export enum ContentUIComponent {
  MetadataStringInput = 'MetadataStringInput',
  MetadataSelectInput = 'MetadataSelectInput',
  MetadataMultiselectInput = 'MetadataMultiselectInput',
  MetadataCheckboxInput = 'MetadataCheckboxInput',
  ContentDataSection = 'ContentDataSection',
  PatternContentEpics = 'PatternContentEpics',
  PatternContentTroubleshooting = 'PatternContentTroubleshooting',
}

export enum ContentAttributes {
  Author = 'Author',
  Rank = 'Rank',
  Tags = 'Tags',
  Metadata = 'Metadata',
}
export enum WorkflowActions {
  EDIT_CONTENT = 'EDIT_CONTENT',
  EDIT_WORKFLOW = 'EDIT WORKFLOW',
  DELETE_WORKFLOW = 'DELETE WORKFLOW',
  EDIT_RESOURCE_AUDIENCE = 'EDIT_RESOURCE_AUDIENCE',
  EDIT_RESOURCE_ACCESS = 'EDIT_RESOURCE_ACCESS',
  EDIT_PEER_REVIEWERS = 'EDIT_PEER_REVIEWERS',
  ASSIGN_TECH_WRITER = 'ASSIGN_TECH_WRITER',
  UNASSIGN_TECH_WRITER = 'UNASSIGN_TECH_WRITER',
  UNPUBLISH = 'UNPUBLISH',
  APG_DISTRIBUTE = 'APG_DISTRIBUTE',
  APG_REVOKE = 'APG_REVOKE',
  DEMOTE_AUDIENCE = 'DEMOTE_AUDIENCE',
  RETRACT_REVIEW = 'RETRACT_REVIEW',
  ADD_PEER_REVIEWERS = 'ADD_PEER_REVIEWERS',
  UNLOCK_WORKFLOW = 'UNLOCK_WORKFLOW',
  SKIP_DRAFT_REVIEW = 'SKIP_DRAFT_REVIEW',
  RESTORE_PUBLISHED_CONTENT_VERSION = 'RESTORE_PUBLISHED_CONTENT_VERSION',
  DELETE_PUBLICATION_VERSION = 'DELETE_PUBLICATION_VERSION',
  RESET_DRAFT = 'RESET_DRAFT',
}

export enum ContentRequestAttributes {
  State = 'State',
  Requestor = 'Requestor',
}

export enum ContentRequestActions {
  MARKED_COMPLETED = 'MARKED_COMPLETED',
  MARKED_DUPLICATED = 'MARKED_DUPLICATED',
}

export enum AWSServiceIcons {
  Alexa = 'Alexa',
  Amplify = 'Amplify',
  ApiGateway = 'ApiGateway',
  AppDiscoveryService = 'AppDiscoveryService',
  Appmesh = 'Appmesh',
  Appstream = 'Appstream',
  Appsync = 'Appsync',
  Artifact = 'Artifact',
  Athena = 'Athena',
  Aurora = 'Aurora',
  AutoScaling = 'AutoScaling',
  Backup = 'Backup',
  Batch = 'Batch',
  Braket = 'Braket',
  CertificateManager = 'CertificateManager',
  Chime = 'Chime',
  Cloud9 = 'Cloud9',
  CloudDirectory = 'CloudDirectory',
  CloudFormation = 'CloudFormation',
  CloudFront = 'CloudFront',
  CloudHSM = 'CloudHSM',
  CloudMap = 'CloudMap',
  CloudSearch = 'CloudSearch',
  CloudTrail = 'CloudTrail',
  CloudWatch = 'CloudWatch',
  CodeBuild = 'CodeBuild',
  CodeCommit = 'CodeCommit',
  CodeDeploy = 'CodeDeploy',
  CodePipeline = 'CodePipeline',
  CodeStar = 'CodeStar',
  Cognito = 'Cognito',
  CommandLineInterface = 'CommandLineInterface',
  Comprehend = 'Comprehend',
  Config = 'Config',
  Connect = 'Connect',
  ControlTower = 'ControlTower',
  // Corretto = 'Corretto',
  DataPipeline = 'DataPipeline',
  DatabaseMigrationService = 'DatabaseMigrationService',
  DataSync = 'DataSync',
  DeepLens = 'DeepLens',
  DeepRacer = 'DeepRacer',
  DeviceFarm = 'DeviceFarm',
  DirectConnect = 'DirectConnect',
  DirectoryService = 'DirectoryService',
  DocumentDB = 'DocumentDB',
  DynamoDB = 'DynamoDB',
  EBS = 'EBS',
  EC2 = 'EC2',
  EC2AutoScaling = 'EC2AutoScaling',
  EC2ContainerRegistry = 'EC2ContainerRegistry',
  EFS = 'EFS',
  ElasticBeanstalk = 'ElasticBeanstalk',
  ElasticContainerService = 'ElasticContainerService',
  // ElasticContainerServiceKubernetes = 'ElasticContainerServiceKubernetes',
  ElasticInference = 'ElasticInference',
  ElasticTranscoder = 'ElasticTranscoder',
  ElastiCache = 'ElastiCache',
  ElasticSearch = 'ElasticSearch',
  ELB = 'ELB',
  // Elemental = 'Elemental',
  EMR = 'EMR',
  Fargate = 'Fargate',
  FirewallManager = 'FirewallManager',
  ForeCast = 'ForeCast',
  FreeRTOS = 'FreeRTOS',
  FSx = 'FSx',
  GameLift = 'GameLift',
  Glacier = 'Glacier',
  GlobalAccelerator = 'GlobalAccelerator',
  Glue = 'Glue',
  Greengrass = 'Greengrass',
  GroundStation = 'GroundStation',
  GuardDuty = 'GuardDuty',
  IAM = 'IAM',
  Inspector = 'Inspector',
  IotCore = 'IotCore',
  KafkaManagedStreaming = 'KafkaManagedStreaming',
  KeyManagementService = 'KeyManagementService',
  Kinesis = 'Kinesis',
  Lambda = 'Lambda',
  Lex = 'Lex',
  LicenseManager = 'LicenseManager',
  LightSail = 'LightSail',
  // Lumberyard = 'Lumberyard',
  MachineLearning = 'MachineLearning',
  Macie = 'Macie',
  ManagedBlockchain = 'ManagedBlockchain',
  // ManagedServices = 'ManagedServices',
  Map = 'Map',
  MigrationHub = 'MigrationHub',
  // MobileHub = 'MobileHub',
  MQ = 'MQ',
  Neptune = 'Neptune',
  OpsWorks = 'OpsWorks',
  Organizations = 'Organizations',
  OutPosts = 'OutPosts',
  PersonalHealthDashboard = 'PersonalHealthDashboard',
  Personalize = 'Personalize',
  Pinpoint = 'Pinpoint',
  Polly = 'Polly',
  QLDB = 'QLDB',
  QuickSight = 'QuickSight',
  RDS = 'RDS',
  RedShift = 'RedShift',
  Rekognition = 'Rekognition',
  RoboMaker = 'RoboMaker',
  Route53 = 'Route53',
  S3 = 'S3',
  SageMaker = 'SageMaker',
  SecretsManager = 'SecretsManager',
  SecurityHub = 'SecurityHub',
  ServelessApplicationRepository = 'ServelessApplicationRepository',
  ServerMigrationService = 'ServerMigrationService',
  ServiceCatalog = 'ServiceCatalog',
  SES = 'SES',
  Shield = 'Shield',
  Snowball = 'Snowball',
  Snowmobile = 'Snowmobile',
  SNS = 'SNS',
  SQS = 'SQS',
  SSO = 'SSO',
  StepFunctions = 'StepFunctions',
  StorageGateway = 'StorageGateway',
  Sumerian = 'Sumerian',
  SystemsManager = 'SystemsManager',
  Textract = 'Textract',
  Timestream = 'Timestream',
  Transcribe = 'Transcribe',
  // TransferSftp = 'TransferSftp',
  Transitgateway = 'Transitgateway',
  Translate = 'Translate',
  TrustedAdvisor = 'TrustedAdvisor',
  VMwareCloudOnAWS = 'VMwareCloudOnAWS',
  VPC = 'VPC',
  WAF = 'WAF',
  WorkDocs = 'WorkDocs',
  WorkMail = 'WorkMail',
  WorkSpaces = 'WorkSpaces',
  XRay = 'XRay',
}

export enum MetricType {
  All = 'Total',
  InternalPublished = 'Internal AWS',
  ExternalPublished = 'AWS + Partner',
  Public = 'APG Public',
  Draft = 'Draft',
  PeerReview = 'In peer review + Pending peer review acceptance',
  PublisherReview = 'In publisher review',
  TechReview = 'In tech review',
  Test = 'Test artifacts',
}

export enum FinalizingGraphState {
  Unassigned = 'Unassigned',
  Assigned = 'Assigned',
  Finalizing = 'Finalizing',
  Finalized = 'Finalized',
  Distributed = 'Distributed',
}

export enum ExpandableSectionState {
  Expanded = 'expanded',
  Hidden = 'hidden',
}

export enum ViewerType {
  History = 'History',
  PublicationReadonly = 'PublicationReadonly',
}

// Called when a user closes the modal by using the close icon button, clicking outside of the modal, or pressing ESC.
// The event detail contains the reason, which can be any of the following: ['closeButton', 'overlay', 'keyboard'].
// https://polaris.a2z.com/components/awsui-modal/?example=default&tabId=api
export enum DismissModalReason {
  Overlay = 'overlay',
  CloseButton = 'closeButton',
  Keyboard = 'keyboard',
}

export enum ScoreBarometerSegmentType {
  LowZero = 'LowZero',
  MedZero = 'MedZero',
  HiZero = 'HiZero',
  Low = 'Low',
  Med = 'Med',
  Hi = 'Hi',
}
